import FJAIVideoGeneratorLeftContainer from './FJAIVideoGeneratorLeft/container/FJAIVideoGeneratorLeftContainer.jsx';
import FJAIVideoGeneratorRightContainer from './FJAIVideoGeneratorRight/container/FJAIVideoGeneratorRightContainer.jsx';
import { useEffect } from 'react';
import FJActionAIVideoGenerator from '../../redux/action/FJActionAIVideoGenerator.js';
import { useDispatch, useSelector } from 'react-redux';
import FJVideoUtil from '../../util/FJVideoUtil.js';
import { AI_GENERATOR_VIDEO_TAB_LIST } from '../../config/dataConfig/FJAIVideoGeneratorData.js';
import useLocalStore from '../../hooks/useLocalStore.js';
import FJUtil from '../../util/FJUtil.js';
import FJEaLogDataUtil from '../../util/FJEaLogDataUtil.js';
import FJMenu from '../../common/components/FJMenu/FJMenu.jsx';

function FJAIVideoGenerator() {
    const dispatch = useDispatch();
    const tabIndex = useSelector(state => state.AIVideoGenerator.tabIndex);
    useLocalStore();

    useEffect(() => {
        if (!FJUtil.isEditPage()) {
            const defaultTab = FJVideoUtil.getAiGeneratorVideoTab();
            dispatch(FJActionAIVideoGenerator.changeTabIndexAction(defaultTab, { ignoreTitle: true }));
            FJUtil.eaLog('ai videos generate page visit', {
                type: FJEaLogDataUtil.getVideoGeneratorType(defaultTab),
                ABtest_model_select: FJUtil.getABTest() ? 'list' : 'window',
            });
        }
    }, [dispatch]);

    const _onChangeTabIndex = item => {
        FJUtil.eaLog('ai videos generate page visit', {
            type: FJEaLogDataUtil.getVideoGeneratorType(item.value),
            ABtest_model_select: FJUtil.getABTest() ? 'list' : 'window',
        });

        dispatch(FJActionAIVideoGenerator.changeTabIndexAction(item.value));
        dispatch(FJActionAIVideoGenerator.toggleModelPickerVisibilityAction(false));
    };

    return (
        <>
            {!FJUtil.isAiVideoGeneratorLandingPage() && (
                <FJMenu
                    tabList={AI_GENERATOR_VIDEO_TAB_LIST}
                    selectTab={AI_GENERATOR_VIDEO_TAB_LIST.findIndex(item => item.value === tabIndex)}
                    onChangeTab={_onChangeTabIndex}
                />
            )}
            <FJAIVideoGeneratorLeftContainer />
            <FJAIVideoGeneratorRightContainer />
        </>
    );
}

export default FJAIVideoGenerator;
